import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { HolidayErrorMessage, HolidayModel } from '@core/services/holiday/holiday.model';
import { HolidayService } from '@core/services/holiday/holiday.service';
import { inputNoWhitespaceValidator } from '@shared/directives/input-no-whitespace.directive';

@Component({
  selector: 'Teranet-HolidayEdit',
  templateUrl: './holiday-edit.component.html',
})
export class HolidayEditComponent implements OnInit {
  editHolidayFormGroup: FormGroup;
  holidayErrorMessage = HolidayErrorMessage;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private holidayService: HolidayService,
    public dialogRef: MatDialogRef<HolidayEditComponent>
  ) {
    this.editHolidayFormGroup = new FormGroup({
      code: new FormControl('', [inputNoWhitespaceValidator, Validators.required]),
      description: new FormControl('', [inputNoWhitespaceValidator, Validators.required]),
      name: new FormControl('', [inputNoWhitespaceValidator, Validators.required]),
    });
  }

  ngOnInit() {
    if (this.data) {
      this.editHolidayFormGroup.patchValue({ ...this.data });
    };
  }

  onClose(): void {
    this.dialogRef.close();
  }

  onSubmit() {
    if (this.editHolidayFormGroup.valid) {
      let holiday: HolidayModel = {
        code: this.editHolidayFormGroup.get('code').value,
        description: this.editHolidayFormGroup.get('description').value,
        id: this.data.id,
        name: this.editHolidayFormGroup.get('name').value,
      };

      this.holidayService.insertOrUpdateHoliday(holiday).subscribe(() => {
        this.dialogRef.close(holiday);
      });
    };
  }
}
